// Message code define

import R from 'app/assets/R'
import { PermissionEnum, PermissionModule } from 'app/common/enum'

// Endpoint
export const RoleEndPoint = {
  ADMIN_GET_ROLE: 'admin/role/search',
  ADMIN_DELETE_ROLE: 'admin/role/delete',
  ADMIN_CREATE_ROLE: 'admin/role/create',
  ADMIN_UPDATE_ROLE: 'admin/role/update',
  ADMIN_CHANGE_STATUS_ROLE: 'admin/role/update-status',
  //permission
  ADMIN_GET_PERMISSION: 'admin/role/permission',
}

export const DefinePermissionEnum = {
  [PermissionEnum.CreateEvent]: {
    keyI18n: R.strings.permission_content_create_event,
  },
  [PermissionEnum.UpdateEvent]: {
    keyI18n: R.strings.permission_content_update_event,
  },
  [PermissionEnum.ReadEvent]: {
    keyI18n: R.strings.permission_content_read_event,
  },
  [PermissionEnum.DeleteEvent]: {
    keyI18n: R.strings.permission_content_delete_event,
  },
  [PermissionEnum.CreateAccount]: {
    keyI18n: R.strings.permission_content_create_account,
  },
  [PermissionEnum.UpdateAccount]: {
    keyI18n: R.strings.permission_content_update_account,
  },
  [PermissionEnum.ReadAccount]: {
    keyI18n: R.strings.permission_content_read_account,
  },
  [PermissionEnum.DeleteAccount]: {
    keyI18n: R.strings.permission_content_delete_account,
  },
  [PermissionEnum.UpdateRoleAccount]: {
    keyI18n: R.strings.permission_content_update_role_account,
  },
  [PermissionEnum.CreateRole]: {
    keyI18n: R.strings.permission_content_create_role,
  },
  [PermissionEnum.UpdateRole]: {
    keyI18n: R.strings.permission_content_update_role,
  },
  [PermissionEnum.ReadRole]: {
    keyI18n: R.strings.permission_content_read_role,
  },
  [PermissionEnum.DeleteRole]: {
    keyI18n: R.strings.permission_content_delete_role,
  },
  [PermissionEnum.ReadRolePermission]: {
    keyI18n: R.strings.permission_content_read_role_permission,
  },
  [PermissionEnum.ReadReport]: {
    keyI18n: R.strings.permission_content_read_report,
  },
  [PermissionEnum.DashboardAdmin]: {
    keyI18n: R.strings.permission_content_dashboard_admin,
  },
  [PermissionEnum.UpdateTradeUnionMember]: {
    keyI18n: R.strings.permission_content_update_trade_union_member,
  },
  [PermissionEnum.ReadTradeUnionMember]: {
    keyI18n: R.strings.permission_content_read_trade_union_member,
  },
  [PermissionEnum.SyncTradeUnionMember]: {
    keyI18n: R.strings.permission_content_sync_trade_union_member,
  },
  [PermissionEnum.CreateRolePermission]: {
    keyI18n: R.strings.permission_content_create_role_permission,
  },
  [PermissionEnum.UpdateRolePermission]: {
    keyI18n: R.strings.permission_content_update_role_permission,
  },
  [PermissionEnum.DeleteRolePermission]: {
    keyI18n: R.strings.permission_content_delete_role_permission,
  },

  [PermissionEnum.CreateTradeUnionMember]: {
    keyI18n: R.strings.permission_content_create_trade_union_member,
  },
  [PermissionEnum.DeleteTradeUnionMember]: {
    keyI18n: R.strings.permission_content_delete_trade_union_member,
  },
  [PermissionEnum.ChangePassword]: {
    keyI18n: R.strings.permission_content_change_password,
  },
  [PermissionEnum.CreateNewTumRegister]: {
    keyI18n: R.strings.permission_content_create_new_tum_register,
  },
  [PermissionEnum.ReadNewTumRegister]: {
    keyI18n: R.strings.permission_content_read_new_tum_register,
  },
  [PermissionEnum.UpdateNewTumRegister]: {
    keyI18n: R.strings.permission_content_update_new_tum_register,
  },
  [PermissionEnum.ApproveNewTumRegister]: {
    keyI18n: R.strings.permission_content_approve_new_tum_register,
  },

  [PermissionEnum.CreateTumHrm]: {
    keyI18n: R.strings.permission_content_create_tum_hrm,
  },
  [PermissionEnum.ReadTumHrm]: {
    keyI18n: R.strings.permission_content_read_tum_hrm,
  },
  [PermissionEnum.UpdateTumHrm]: {
    keyI18n: R.strings.permission_content_update_tum_hrm,
  },
  [PermissionEnum.ExportTumHrm]: {
    keyI18n: R.strings.permission_content_export_tum_hrm,
  },

  [PermissionEnum.CreateUnit]: {
    keyI18n: R.strings.permission_content_create_unit,
  },
  [PermissionEnum.ReadUnit]: {
    keyI18n: R.strings.permission_content_read_unit,
  },
  [PermissionEnum.UpdateUnit]: {
    keyI18n: R.strings.permission_content_update_unit,
  },
  [PermissionEnum.DeleteUnit]: {
    keyI18n: R.strings.permission_content_delete_unit,
  },
  [PermissionEnum.ExportUnit]: {
    keyI18n: R.strings.permission_content_export_unit,
  },

  [PermissionEnum.ExportEvent]: {
    keyI18n: R.strings.permission_content_export_event,
  },
  [PermissionEnum.DeclareTeam]: {
    keyI18n: R.strings.permission_content_declare_team,
  },
  [PermissionEnum.ExportAccount]: {
    keyI18n: R.strings.permission_content_export_account,
  },
  [PermissionEnum.ExportTradeUnionMember]: {
    keyI18n: R.strings.permission_content_export_trade_union_member,
  },
  [PermissionEnum.ExportRole]: {
    keyI18n: R.strings.permission_content_export_role,
  },
  [PermissionEnum.CreateActivityEngagement]: {
    keyI18n: R.strings.permission_content_create_activity_engagement,
  },
  [PermissionEnum.ReadActivityEngagement]: {
    keyI18n: R.strings.permission_content_read_activity_engagement,
  },
  [PermissionEnum.UpdateActivityEngagement]: {
    keyI18n: R.strings.permission_content_update_activity_engagement,
  },
  [PermissionEnum.DeleteActivityEngagement]: {
    keyI18n: R.strings.permission_content_delete_activity_engagement,
  },
  [PermissionEnum.ExportActivityEngagement]: {
    keyI18n: R.strings.permission_content_export_activity_engagement,
  },
  [PermissionEnum.CreateSchool]: {
    keyI18n: R.strings.permission_content_create_school,
  },
  [PermissionEnum.ReadSchool]: {
    keyI18n: R.strings.permission_content_read_school,
  },
  [PermissionEnum.UpdateSchool]: {
    keyI18n: R.strings.permission_content_update_school,
  },
  [PermissionEnum.DeleteSchool]: {
    keyI18n: R.strings.permission_content_delete_school,
  },
  [PermissionEnum.ExportSchool]: {
    keyI18n: R.strings.permission_content_export_school,
  },

  [PermissionEnum.UpdateEndTimeEvent]: {
    keyI18n: R.strings.permission_content_update_end_time_event,
  },

  [PermissionEnum.CreateDegree]: {
    keyI18n: R.strings.permission_content_create_degree,
  },
  [PermissionEnum.ReadDegree]: {
    keyI18n: R.strings.permission_content_read_degree,
  },
  [PermissionEnum.UpdateDegree]: {
    keyI18n: R.strings.permission_content_update_degree,
  },
  [PermissionEnum.DeleteDegree]: {
    keyI18n: R.strings.permission_content_delete_degree,
  },
  [PermissionEnum.ExportDegree]: {
    keyI18n: R.strings.permission_content_export_degree,
  },

  [PermissionEnum.CreateTradeUnionMemberInYourUnit]: {
    keyI18n:
      R.strings.permission_content_create_trade_union_member_in_your_unit,
  },
  [PermissionEnum.ReadTradeUnionMemberInYourUnit]: {
    keyI18n: R.strings.permission_content_read_trade_union_member_in_your_unit,
  },
  [PermissionEnum.UpdateTradeUnionMemberInYourUnit]: {
    keyI18n:
      R.strings.permission_content_update_trade_union_member_in_your_unit,
  },
  [PermissionEnum.DeleteTradeUnionMemberInYourUnit]: {
    keyI18n:
      R.strings.permission_content_delete_trade_union_member_in_your_unit,
  },
  [PermissionEnum.ExportTradeUnionMemberInYourUnit]: {
    keyI18n:
      R.strings.permission_content_export_trade_union_member_in_your_unit,
  },

  [PermissionEnum.CreateNewTumRegisterInYourUnit]: {
    keyI18n:
      R.strings.permission_content_create_new_tum_register_with_your_unit,
  },
}

export const DefinePermissionModuleEnum = {
  [PermissionModule.Event]: {
    keyI18n: R.strings.permission_module_content_event,
  },
  [PermissionModule.Account]: {
    keyI18n: R.strings.permission_module_content_account,
  },
  [PermissionModule.Report]: {
    keyI18n: R.strings.permission_module_content_report,
  },
  [PermissionModule.TradeUnionMember]: {
    keyI18n: R.strings.permission_module_content_trade_union_member,
  },
  [PermissionModule.RoleManagement]: {
    keyI18n: R.strings.permission_module_content_role_management,
  },
  [PermissionModule.RolePermission]: {
    keyI18n: R.strings.permission_module_content_role_permission,
  },
  [PermissionModule.NewTumRegister]: {
    keyI18n: R.strings.permission_module_content_new_tum_register,
  },
  [PermissionModule.TumHrm]: {
    keyI18n: R.strings.permission_module_content_tum_hrm,
  },
  [PermissionModule.Unit]: {
    keyI18n: R.strings.permission_module_content_unit,
  },
  [PermissionModule.ActivityEngagement]: {
    keyI18n: R.strings.permission_module_content_activity_engagement,
  },
  [PermissionModule.School]: {
    keyI18n: R.strings.permission_module_content_school,
  },
  [PermissionModule.Other]: {
    keyI18n: R.strings.permission_module_content_other,
  },

  [PermissionModule.Degree]: {
    keyI18n: R.strings.permission_module_content_degree,
  },
}
